import { schema } from 'normalizr';
import { tryToParseJson } from '../utilities';

const getSchemaUserId = entity => {
  let id;
  // Invited users have no ID, so use their email address:
  if (typeof entity.id === 'undefined' && entity.account_status === 'invited') {
    id = entity.auth_info ? entity.auth_info.username : entity.username;
  }
  // Because of this, IDs need to be strings.
  if (typeof entity.id !== 'undefined') {
    id = entity.id.toString();
  }
  return id;
};

const changeAttributeKey = (entity, oldKey, newKey) => {
  if (
    typeof entity[newKey] === 'undefined' &&
    typeof entity[oldKey] !== 'undefined'
  ) {
    entity[newKey] = entity[oldKey];
  }

  if (
    typeof entity[newKey] !== 'undefined' &&
    typeof entity[oldKey] !== 'undefined'
  ) {
    delete entity[oldKey];
  }
};

export const user = new schema.Entity(
  'users',
  {},
  {
    idAttribute: entity => getSchemaUserId(entity),
    processStrategy: entity => {
      const newEntity = { ...entity };

      // We use account status for styling user list rows
      if (!entity.account_status) {
        newEntity.account_status = entity.invites ? 'invited' : 'active';
      }

      if (newEntity.account_status === 'invited') newEntity.isEducator = true;

      // The username should be inside auth_info.
      if (typeof entity.username !== 'undefined') {
        newEntity.auth_info = { username: entity.username };
        delete newEntity.username;
      }

      // We’re moving to snake case for API attributes
      changeAttributeKey(newEntity, 'givenName', 'given_name');
      changeAttributeKey(newEntity, 'familyName', 'family_name');

      newEntity.id = getSchemaUserId(entity);
      if (entity.roles && entity.roles.length) {
        const firstSchoolRoles = entity.roles[0][1];
        const isSuperAdmin = entity.super_admin || false;
        newEntity.isStudent = firstSchoolRoles.includes('STUDENT');
        newEntity.isEducator = !firstSchoolRoles.includes('STUDENT');
        newEntity.isAdmin =
          firstSchoolRoles.includes('SCHOOL_ADMIN') || isSuperAdmin;
        newEntity.isSuperAdmin = isSuperAdmin;
        newEntity.isDeactivated = false;

        if (newEntity.isSuperAdmin) {
          newEntity.roleStringId = 'user_role.tinybop_admin';
        } else if (newEntity.isAdmin) {
          newEntity.roleStringId = 'user_role.school_admin';
        } else if (newEntity.isEducator) {
          newEntity.roleStringId = 'user_role.teacher';
        } else {
          newEntity.roleStringId = 'user_role.student';
        }
      } else {
        newEntity.isDeactivated = true;
        newEntity.roleStringId = 'user_role.deactivated';
      }
      return newEntity;
    },
  }
);

export const _class = new schema.Entity(
  'classes',
  {
    teachers: [user],
    students: [user],
  },
  {}
);

export const school = new schema.Entity(
  'schools',
  {},
  {
    processStrategy: entity => {
      const newEntity = { ...entity };
      // There might be some old tests where the meta was not stringified
      // JSON, so we need to be sure it’s not.
      const parsedMeta = tryToParseJson(newEntity.meta);
      newEntity.meta =
        parsedMeta.valid && newEntity.meta !== null ? newEntity.meta : '{}';

      return newEntity;
    },
  }
);

export const arrayOfUsers = new schema.Array(user);
export const arrayOfClasses = new schema.Array(_class);
export const arrayOfSchools = new schema.Array(school);
